import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-aa163ba4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "selected-session-heading" }
const _hoisted_2 = { "data-test": "selected-session-heading-title" }
const _hoisted_3 = { class: "visible-mobile" }
const _hoisted_4 = {
  key: 0,
  class: "mobile-landscape-start-button-wrapper visible-mobile"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "visible-wide" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "circle-wrapper" }
const _hoisted_10 = { class: "circle-background" }
const _hoisted_11 = ["data-test"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "circle-center-content visible-wide" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = ["onClick", "data-session-id", "data-test"]
const _hoisted_18 = ["data-test"]
const _hoisted_19 = { class: "circle-module-inner" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 2,
  class: "develop-icon"
}
const _hoisted_23 = { class: "mobile-portrait-start-button-wrapper visible-mobile" }
const _hoisted_24 = ["href"]

import { computed, onMounted, onUnmounted, ref } from "vue";
import cms from "../../services/cms/cms";
import { CmsRichText } from "../../services/cms/cms-type-definitions";
import { SessionApiModel, SessionsApiModel } from "../../api-models";
import { FullSessionsCircle, SessionsCircle } from "../../components/sessions/session-circle";
import MobileSessionsCircle from "../../components/sessions/mobile-session-circle";
import {
  createSessionsViewModelFromApiModel,
  SessionsViewModel,
} from "../../components/sessions/session-models";

export interface CmsSessionApiModel extends SessionApiModel {
  unavailableDescriptionFromCms: CmsRichText | undefined;
  availableDescriptionFromCms: CmsRichText | undefined;
  buttonText: string | undefined;
  itemTypeText: string | undefined;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'sessions-wheel',
  props: {
    model: {},
    wheelColour: { default: "rgb(109, 200, 191)" },
    includeBackButton: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const selectedSessionIndex = ref(0);
const newSelectedSessionIndex = ref(0);
const isChanging = ref(false);
const circle = ref<SessionsCircle>();
const isInitializingCircle = ref(false);
const initializingTimeout = ref<any>();

const viewModel = computed(() => {
  const model = createSessionsViewModelFromApiModel(props.model);
  return model;
});

const selectedSession = computed(
  () => viewModel.value.sessions[selectedSessionIndex.value] as CmsSessionApiModel,
);
const newSelectedSession = computed(
  () => viewModel.value.sessions[newSelectedSessionIndex.value] as CmsSessionApiModel,
);
const unavailableHtml = computed(() => {
  if (newSelectedSession.value.unavailableDescriptionFromCms) {
    return cms.asHtml(newSelectedSession.value.unavailableDescriptionFromCms);
  }
  return `<p>${(newSelectedSession.value.unavailableDescription ?? []).join("</p><p>")}</p>`;
});

function isLastAvailableSession(session: SessionApiModel): boolean {
  return session.index === viewModel.value.lastAvailableSessionIndex;
}

const availableHtml = computed(() => {
  if (newSelectedSession.value.availableDescriptionFromCms) {
    return cms.asHtml(newSelectedSession.value.availableDescriptionFromCms);
  }
  return `<p>${(newSelectedSession.value.availableDescription ?? []).join("</p><p>")}</p>`;
});

const description = computed(() => {
  let desc =
    newSelectedSession.value.unavailableDescriptionFromCms ??
    newSelectedSession.value.unavailableDescription;
  if (newSelectedSession.value.isAvailable) {
    desc =
      newSelectedSession.value.availableDescriptionFromCms ??
      newSelectedSession.value.availableDescription;
  }

  if (!desc) {
    return null;
  }

  if (typeof desc[0] === "string") {
    return `<p>${(desc as string[]).join("</p><p>")}</p>`;
  }
  return cms.asHtml(desc as any);
});

const startButtonText = computed(() => {
  if (newSelectedSession.value) {
    if (newSelectedSession.value.id === "Develop") {
      return "Start Develop";
    }

    if (newSelectedSession.value.buttonText) {
      return newSelectedSession.value.buttonText;
    }
  }

  return "Start Session";
});

const canStartSelectedSession = computed(() => {
  return newSelectedSession.value.isAvailable;
});

const sessionCount = computed(() => viewModel.value.sessions.length);

function itemTypeText(session: CmsSessionApiModel): string {
  return session.itemTypeText || "Session";
}

function getTransitionDurationInSeconds(fast: boolean): number {
  if (window.innerWidth < 1024) {
    return fast ? 0.2 : 0.3;
  }

  return fast ? 0.5 : 1;
}

function selectSession(sessionIndex: number): void {
  selectedSessionIndex.value = sessionIndex;
  isChanging.value = true;
  circle.value!.selectSession(sessionIndex, getTransitionDurationInSeconds(false)).then(() => {
    isChanging.value = false;
    newSelectedSessionIndex.value = selectedSessionIndex.value;
  });
}

function onCircleDragEnd(nearestSessionIndex: number): void {
  if (nearestSessionIndex === selectedSessionIndex.value) {
    circle.value!.selectSession(nearestSessionIndex, getTransitionDurationInSeconds(true));
  } else {
    selectSession(nearestSessionIndex);
  }
}

function getInitialOffset(windowWidth: number, windowHeight: number): number {
  if (windowWidth < 1024) {
    return windowHeight >= windowWidth ? 90 : 25;
  }

  return 360 * (-1 / viewModel.value.sessions.length); // Top -left
}

const circleRef = ref();
const circleModules = ref();
const circleDragArea = ref();
const circleArcs = ref();

function initializeCircle() {
  if (circle.value) {
    circle.value.destroy();
  }

  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  circle.value = circleRef.value as any;

  const circleRadiusInPixels = (circle.value as any).clientWidth / 2;
  const initialOffsetInDegrees = getInitialOffset(windowWidth, windowHeight);
  circle.value = windowWidth < 1024 ? new MobileSessionsCircle() : new FullSessionsCircle();
  circle.value.initialize(
    viewModel.value.sessions.map((s) => s.id),
    circleRadiusInPixels,
    initialOffsetInDegrees,
    circleDragArea.value as HTMLElement,
    circleArcs.value as HTMLElement,
    Array.from((circleModules.value as HTMLElement).childNodes) as HTMLElement[],
    onCircleDragEnd,
  );
  circle.value.selectSession(selectedSessionIndex.value, 0);
}

function onResize() {
  if (initializingTimeout.value) {
    clearTimeout(initializingTimeout.value);
  }

  isInitializingCircle.value = true;
  initializingTimeout.value = setTimeout(() => {
    initializeCircle();
    isInitializingCircle.value = false;
    initializingTimeout.value = undefined;
  }, 200);
}

onMounted(() => {
  selectedSessionIndex.value = viewModel.value.initialSelectedSessionIndex;
  newSelectedSessionIndex.value = selectedSessionIndex.value;

  isInitializingCircle.value = true;
  setTimeout(() => {
    initializeCircle();
    isInitializingCircle.value = false;
  });
  window.addEventListener("resize", onResize);
});

function handleSessionClick(sessionIndex: number): void {
  if (sessionIndex === selectedSessionIndex.value) {
    return;
  }

  selectSession(sessionIndex);
}

onUnmounted(() => {
  window.removeEventListener("resize", onResize);
});

const oldImage = computed(() => {
  const image = selectedSession.value.imageUrl;
  if (image) {
    return `url(${image})`;
  }

  return undefined;
});

const newImage = computed(() => {
  const image = newSelectedSession.value.imageUrl;
  if (image) {
    return `url(${image})`;
  }

  return undefined;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "session-wheel",
    style: _normalizeStyle(`--wheel-colour: ${_ctx.wheelColour};`)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["container sessions-grid-layout-container", [
        isChanging.value ? 'changing' : '',
        'new-session-' + (selectedSessionIndex.value + 1),
        'old-session-' + (newSelectedSessionIndex.value + 1),
        isInitializingCircle.value ? 'initializing-circle' : '',
      ]])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "selected-session-heading-background-old",
          style: _normalizeStyle({ backgroundImage: oldImage.value })
        }, null, 4),
        _createElementVNode("div", {
          class: "selected-session-heading-background-new",
          style: _normalizeStyle({ backgroundImage: newImage.value })
        }, null, 4),
        _createElementVNode("h1", _hoisted_2, _toDisplayString(newSelectedSession.value.fullTitle), 1),
        _createElementVNode("h3", _hoisted_3, _toDisplayString(newSelectedSession.value.durationDescription), 1),
        (canStartSelectedSession.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("a", {
                class: "btn btn-primary btn-lg",
                href: newSelectedSession.value.url,
                target: "_self"
              }, "Start", 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["selected-session-info", { 'include-back-button': _ctx.includeBackButton }])
      }, [
        _createElementVNode("h3", _hoisted_6, _toDisplayString(newSelectedSession.value.durationDescription), 1),
        _createElementVNode("div", { innerHTML: description.value }, null, 8, _hoisted_7),
        (newSelectedSession.value.isAvailable && isLastAvailableSession(newSelectedSession.value))
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
              _createElementVNode("b", null, _toDisplayString(newSelectedSession.value.callToAction), 1)
            ]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          ref_key: "circleRef",
          ref: circleRef,
          class: "circle"
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "circle-background-new",
              style: _normalizeStyle({ backgroundImage: newImage.value })
            }, null, 4),
            _createElementVNode("div", {
              class: "circle-background-old",
              style: _normalizeStyle({ backgroundImage: oldImage.value })
            }, null, 4)
          ]),
          _createElementVNode("div", {
            ref_key: "circleArcs",
            ref: circleArcs,
            class: _normalizeClass(["circle-arcs visible-wide", 'circle-arcs-' + sessionCount.value])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(viewModel.value.sessions, (session, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["circle-arc", session.theme + ' ' + (session.isCompleted ? 'completed' : '')]),
                key: i,
                "data-test": `circle-arc-${i}`
              }, _hoisted_13, 10, _hoisted_11))
            }), 128))
          ], 2),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("h2", null, _toDisplayString(newSelectedSession.value.shortTitle), 1),
            (canStartSelectedSession.value && newSelectedSession.value.itemTypeText === 'Step')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "btn btn-lg btn-primary-forward-bold",
                  href: newSelectedSession.value.url,
                  target: "_self",
                  "data-test": "start-session-button"
                }, _toDisplayString(startButtonText.value), 9, _hoisted_15))
              : (canStartSelectedSession.value)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: "btn btn-lg btn-primary",
                    href: newSelectedSession.value.url,
                    target: "_self",
                    "data-test": "start-session-button"
                  }, _toDisplayString(startButtonText.value), 9, _hoisted_16))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            ref_key: "circleDragArea",
            ref: circleDragArea,
            class: "circle-drag-area"
          }, null, 512),
          _createElementVNode("div", {
            ref_key: "circleModules",
            ref: circleModules,
            class: "circle-modules"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(viewModel.value.sessions, (session, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["circle-module", [
                {
                  available: session.isAvailable,
                  completed: session.isCompleted,
                  selected: selectedSessionIndex.value === session.index,
                },
                session.theme,
              ]]),
                key: index,
                onClick: ($event: any) => (handleSessionClick(index)),
                "data-session-id": session.id,
                "data-test": 'session-' + session.id + '-module'
              }, [
                _createElementVNode("div", {
                  "data-test": `circle-${session.id}`,
                  class: _normalizeClass(["circle-module-outer", {
                  'circle-module-outer-develop': session.id === 'Develop',
                }])
                }, [
                  _createElementVNode("div", _hoisted_19, [
                    (session.id !== 'Develop')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(itemTypeText(session)), 1))
                      : _createCommentVNode("", true),
                    (session.id !== 'Develop')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(session.index + 1), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_22))
                  ])
                ], 10, _hoisted_18)
              ], 10, _hoisted_17))
            }), 128))
          ], 512)
        ], 512)
      ]),
      _createElementVNode("div", _hoisted_23, [
        (canStartSelectedSession.value)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "btn btn-primary btn-lg",
              href: newSelectedSession.value.url,
              target: "_self",
              "data-test": "start-session-button"
            }, _toDisplayString(startButtonText.value), 9, _hoisted_24))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ], 4))
}
}

})